<div *ngIf="loading" class="loading-container">
  <mat-progress-spinner
    mode="indeterminate">
  </mat-progress-spinner>
</div>
